export default __webpack_public_path__ + "static/5-d67b2c6b39348c0905b5f2455f2c959f.jpg";